module.exports = __webpack_public_path__ + "img/profile.1d0b1051.svg";